import { ArrowDownCircle, ArrowUpCircle, Scale } from "lucide-react";
import { reais, type LancamentoDaLista } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";

function somar(linhas: LancamentoDaLista[], tipo: "ENTRADA" | "SAIDA") {
  let total = 0;
  let pago = 0;
  for (const l of linhas) {
    if (l.tipo !== tipo || !l.contaNoTotal) continue;
    total += l.valorCents;
    if (l.pagoEm) pago += l.valorCents;
  }
  return { total, pago };
}

/** Entradas, saídas e saldo dos lançamentos do mês (receita de pedidos ainda não entra aqui). */
export function ResumoDosLancamentos({ linhas }: { linhas: LancamentoDaLista[] }) {
  const entradas = somar(linhas, "ENTRADA");
  const saidas = somar(linhas, "SAIDA");
  const saldo = entradas.total - saidas.total;
  const cartoes = [
    { rotulo: "Entradas", valor: entradas.total, sub: `${reais(entradas.pago)} recebido`, icone: ArrowUpCircle, cor: "text-emerald-600" },
    { rotulo: "Saídas", valor: saidas.total, sub: `${reais(saidas.pago)} pago`, icone: ArrowDownCircle, cor: "text-red-600" },
    { rotulo: "Saldo do mês", valor: saldo, sub: "Entradas menos saídas", icone: Scale, cor: saldo >= 0 ? "text-emerald-600" : "text-red-600" },
  ];
  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3">
      {cartoes.map((c) => (
        <div key={c.rotulo} className="min-w-0 rounded-xl border border-zinc-200 bg-white p-3 shadow-sm sm:p-4 dark:border-border dark:bg-card">
          <div className="flex items-center gap-1.5 truncate text-[11px] font-medium sm:gap-2 sm:text-xs text-zinc-500 dark:text-muted-foreground">
            <c.icone className={cn("h-4 w-4 shrink-0", c.cor)} />
            {c.rotulo}
          </div>
          <p className={cn("mt-1 truncate text-sm font-bold tabular-nums sm:text-xl", c.rotulo === "Saldo do mês" ? c.cor : "text-zinc-900 dark:text-foreground")}>{reais(c.valor)}</p>
          <p className="hidden text-[11px] text-zinc-500 sm:block dark:text-muted-foreground">{c.sub}</p>
        </div>
      ))}
    </div>
  );
}
